module.exports = __webpack_public_path__ + "img/78.9.TU.c9ecefca.png";